// extracted by mini-css-extract-plugin
export var entityChip = "_tf-0";
export var entityChipMissing = "_tf-1";